import { EntityStatusBadgeVariant } from '@frontend/common';
import { TransactionState } from '@frontend/transaction/types';
import React from 'react';

import { TransactionStateBadgeProps } from './transaction-state-badge.component';

interface ViewProps {
    displayName: React.ReactNode;
    variant: EntityStatusBadgeVariant;
}

const useTransactionStateBadge = (props: TransactionStateBadgeProps): ViewProps => {
    return {
        displayName: TransactionState.getByValue(props.state)?.displayName || 'Unknown',
        variant: TransactionState.getBadgeVariant(props.state)
    };
};

export default useTransactionStateBadge;
